import {eatalianoAxios} from "@/data/api/http/axios";
import {DashboardStatus} from "@/data/entities/dashboard";

export const getDashboardStatus = (restaurantId: number): Promise<DashboardStatus> => (
    eatalianoAxios
        .get(`/admin/dashboard/${restaurantId}`)
        .then(response => response.data)
);